export const ProductData = `
    id
    name
    category
`;
